export default class AvailabilityRestrictionCheckRequest {
    shiftIds: string[];  
}